import {UserContext} from '../../application/app-context/user-context/user-context';
import {ApplicationState} from '../app-launcher/model/app-launcher';
import {TAGS} from './model/constante/event-tags';
import {Link} from './model/link';
import {LinkTypeEnum} from './model/link-type.enum';

export const getApplicationTagList = (userContext: UserContext): string => {
  return userContext.user.appLauncher.applications.filter(app => app.state === ApplicationState.IS_ENABLED)
                    .filter(app => TAGS.has(app.appId))
                    .map(app => tagAppProvider(app.appId))
                    .join('|');
};

export const tagAppProvider = (appId: string): string => {
  return TAGS.get(appId).join('|');
};

export const getListSubscribe = (listTags: Array<string>): Array<string> => {
  return listTags.filter(tag => tag.includes('-subscribe'));
};

export const getListAdvertise = (listTags: Array<string>): Array<string> => {
  return listTags.filter(tag => tag.includes('-advertise'));
};

export const getLink = (links: Array<Link>, linkType: LinkTypeEnum): string => {
  if (links.filter(link => link.typeLink === linkType).length > 0) {
    return links.filter(link => link.typeLink === linkType).shift().link;
  }

  return undefined;
};
